import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import FaIcon from '../FaIcon';
import { getAllGames } from '../../games';
import { useGameStatuses } from '../../contexts/GameStatusesContext';
import { GAME_STATUS, getStatusText, toDateFormat } from '../../util';
import { GOOGLE_INTERSTITIAL_INELIGIBLE_ATTRIBUTES } from '../../ads/googleInterstitialAttributes';
import styles from '../../styles/game/GameResultsScreen.module.css';

export default function GameResultsCircuit({ currentGame, onGameClick, linkProps = GOOGLE_INTERSTITIAL_INELIGIBLE_ATTRIBUTES }) {
  const today = toDateFormat(new Date());
  const games = useMemo(() => getAllGames().filter((game) => !game.hidden), []);
  const gameData = useMemo(() => games.map((game) => ({
    gameId: game.id, games: [{ date: today }],
  })), [games, today]);
  const { getGameStatus, isLoading, error } = useGameStatuses(gameData, true, {
    scopeKey: `results_circuit:${currentGame}:${today}`,
    priority: 'high',
    subscribeOnly: false,
  });

  return (
    <section className={styles.circuit} aria-label="Il circuito di oggi">
      <h3>Il circuito di oggi</h3>
      <div className={styles.circuitGrid}>
        {games.map((game) => {
          const GameIcon = game.icon;
          const savedStatus = getGameStatus(game.id, today);
          const status = savedStatus ?? GAME_STATUS.NOT_STARTED;
          const statusText = savedStatus == null && (isLoading || error)
            ? (error ? 'Stato non disponibile' : 'Stato in caricamento') : getStatusText(status);
          const label = `${game.displayName} di oggi — ${statusText}`;
          return (
            <Link key={game.id} to={`/${game.pathName}/${today}`}
              className={styles.circuitGame} style={{ backgroundColor: game.backgroundColor }}
              title={label} aria-label={label}
              {...linkProps}
              {...(game.id === currentGame ? GOOGLE_INTERSTITIAL_INELIGIBLE_ATTRIBUTES : {})}
              onClick={(event) => onGameClick?.(event, game.id, today, savedStatus)}>
              <GameIcon size={30} status={status} backgroundColor={game.backgroundColor} />
              {status === GAME_STATUS.FINISHED && (
                <span className={styles.circuitCompleted} aria-hidden="true"><FaIcon className="fas fa-check" /></span>
              )}
            </Link>
          );
        })}
      </div>
    </section>
  );
}
